import React from 'react';
import { useNavigate } from 'react-router-dom';

const AccessDeniedPage = () => {
  const navigate = useNavigate();
  return (
    <div style={{ maxWidth: 720, margin: '120px auto', padding: '0 16px', textAlign: 'center' }}>
      <h1 style={{ fontSize: 32, marginBottom: 12 }}>Access Denied</h1>
      <p style={{ color: '#666', marginBottom: 24 }}>You do not have permission to view this page.</p>
      <div style={{ display: 'flex', gap: 12, justifyContent: 'center' }}>
        <button onClick={() => navigate('/dashboard')} style={{ padding: '10px 16px', borderRadius: 8, border: '1px solid #ccc', cursor: 'pointer' }}>Back to Dashboard</button>
        <button onClick={() => navigate('/')} style={{ padding: '10px 16px', borderRadius: 8, border: '1px solid #ccc', cursor: 'pointer' }}>Home</button>
      </div>
    </div>
  );
};

export default AccessDeniedPage;


